/**
 * Whitelist of Medendo team members who should have special privileges.
 *
 * Team members in this list get:
 *  - Access to hidden or experimental features that are normally disabled for end-users.
 *  - Console output enabled even in production builds (for debugging and diagnostics).
 *
 * This function checks whether a given user’s email belongs to the Medendo internal team.
 */

const MEDENDO_TEAM_WHITE_LIST = new Set([
    'andrei@medendo.com',
    'arjan@medendo.com',
    'minfei@medendo.com',
    'yiyi@medendo.com',
    'sonya@medendo.com',
    'walco@medendo.com',
])
export function isUserFromMedendoTeam(email?: string) {
    return email ? MEDENDO_TEAM_WHITE_LIST.has(email.toLowerCase()) : false
}
